import { updateListMethod } from '../../utils/list'
import { 
  USERS_UPDATE_LIST,
  USERS_UPDATE_LIST_METHOD,
  USERS_UPDATE_PREVIEW,
  USERS_UPDATE_FORM,
  USERS_UPDATE_INPUT_FORM
} from '../actions/user.actions'

const formDefault = {
  address: "",   
  birthdate: null,
  city: "",
  code: "",
  country: "",
  classes: [],
  email: "",
  firstName: "",
  gender: "",
  lastName: "",
  photo: "",
  postalCode: "",
  roles: [],
  state: "",
  telephone: "",
  title:""
}

const initState = {
  list: [],
  totalList: 0,
  preview: null,
  form: { ...formDefault },
}

const userReducer = (state = initState, action) => {
  const newState = { ...state }
  const { payload } = action

  switch (action.type) {
    case USERS_UPDATE_LIST:
      newState.list = payload.users
      newState.totalList = payload.count
    break
    case USERS_UPDATE_LIST_METHOD:
      newState.list = updateListMethod(payload.method, payload.data, newState.list);
      if (payload.method === 'DELETE') {
        newState.totalList--
      }
      if (payload.method === 'POST') {
        newState.totalList++
      }
    break
    case USERS_UPDATE_PREVIEW:
      newState.preview = payload.preview
    break
    case USERS_UPDATE_FORM:
      if (payload.form) {
        newState.form = { ...payload.form }
      } else {
        newState.form = { ...formDefault }
      }
    break
    case USERS_UPDATE_INPUT_FORM:       
      const { name, value } = payload
      let form = newState.form
      if (form[name]) {
        form[name] = value
      }
      newState.form = form
    break
    default:
    break
  }

  return newState
}

export default userReducer
